// School-wide constants
export const SCHOOL = {
  name: "Yusuf Maitama Sule College of Education",
  shortName: "YMS COE",
  fullName: "Yusuf Maitama Sule College of Education Kano Ghari",
  location: "Kano Ghari, Kano State, Nigeria",
  motto: "Knowledge, Integrity and Service",
  established: 2014,
  email: "info@ymscoe.edu.ng",
  phone: "+234 800 000 0000",
  address: "P.M.B 0000, Kano Ghari, Kano State, Nigeria",
  website: "https://ymscoe.edu.ng",
  logo: "/logo.png",
} as const

export const API_URL = import.meta.env.VITE_API_URL || ""

export const GRADE_SYSTEM = [
  { min: 70, max: 100, grade: "A", point: 4.0, remark: "DISTINCTION" },
  { min: 60, max: 69.99, grade: "B", point: 3.5, remark: "CREDIT" },
  { min: 50, max: 59.99, grade: "C", point: 3.0, remark: "MERIT" },
  { min: 45, max: 49.99, grade: "D", point: 2.5, remark: "PASS" },
  { min: 40, max: 44.99, grade: "E", point: 2.0, remark: "PASS" },
  { min: 0, max: 39.99, grade: "F", point: 0.0, remark: "FAIL" },
]

export function calculateGrade(totalScore: number) {
  for (const g of GRADE_SYSTEM) {
    if (totalScore >= g.min && totalScore <= g.max) return g
  }
  return GRADE_SYSTEM[GRADE_SYSTEM.length - 1]
}

export function calculateGPA(results: { totalScore: number; creditUnit: number }[]) {
  let totalPoints = 0
  let totalCredits = 0
  for (const r of results) {
    const g = calculateGrade(r.totalScore)
    totalPoints += g.point * r.creditUnit
    totalCredits += r.creditUnit
  }
  return totalCredits > 0 ? totalPoints / totalCredits : 0
}

export const LEVELS = ["NCE_1", "NCE_2", "NCE_3"] as const
export const SEMESTERS = ["FIRST", "SECOND"] as const

export const FEE_TYPES = [
  "ACCEPTANCE", "TUITION", "REGISTRATION", "LIBRARY", "LAB", "SPORTS", "MEDICAL", "EXAM", "OTHER",
]

export const PAYMENT_GATEWAYS = ["PAYSTACK", "FLUTTERWAVE", "MONNIFY"]

export const SECURITY = {
  SESSION_TIMEOUT_MINUTES: 10,
  MAX_LOGIN_ATTEMPTS: 5,
  LOGIN_LOCKOUT_MINUTES: 20,
}

export const ADMIN_TABS = [
  { key: "overview", label: "Overview", icon: "LayoutDashboard" },
  { key: "applications", label: "Applications", icon: "FileText" },
  { key: "students", label: "Students", icon: "GraduationCap" },
  { key: "courses", label: "Courses", icon: "BookOpen" },
  { key: "results", label: "Results", icon: "Award" },
  { key: "certificates", label: "Certificates", icon: "ScrollText" },
  { key: "transcripts", label: "Transcripts", icon: "FileSpreadsheet" },
  { key: "downloads", label: "Downloads", icon: "Download" },
  { key: "announcements", label: "Announcements", icon: "Megaphone" },
  { key: "calendar", label: "Calendar", icon: "Calendar" },
  { key: "news", label: "News & Events", icon: "Newspaper" },
  { key: "admission", label: "Admission Control", icon: "DoorOpen" },
  { key: "payments", label: "Payments", icon: "CreditCard" },
  { key: "access-codes", label: "Access Codes", icon: "Key" },
  { key: "audit-logs", label: "Audit Logs", icon: "History" },
  { key: "messages", label: "Site Messages", icon: "Mail" },
  { key: "users", label: "User Permissions", icon: "ShieldCheck" },
  { key: "reports", label: "Reports", icon: "BarChart3" },
  { key: "knowledge-base", label: "Knowledge Base", icon: "Brain" },
  { key: "settings", label: "Settings", icon: "Settings" },
] as const

export const SITE_NAV = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/programs", label: "Programs" },
  { href: "/faculties", label: "Faculties" },
  { href: "/admission-requirements", label: "Admission" },
  { href: "/fees", label: "Fees" },
  { href: "/news", label: "News & Events" },
  { href: "/downloads", label: "Downloads" },
  { href: "/teaching-practice", label: "Teaching Practice" },
  { href: "/faq", label: "FAQ" },
  { href: "/contact", label: "Contact" },
] as const

export function formatNaira(amount: number) {
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
  }).format(amount)
}

export function formatDate(ts?: number) {
  if (!ts) return "—"
  return new Date(ts).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })
}

export function formatDateTime(ts?: number) {
  if (!ts) return "—"
  return new Date(ts).toLocaleString("en-US", {
    year: "numeric", month: "short", day: "numeric",
    hour: "2-digit", minute: "2-digit",
  })
}
